import React from 'react';
import styles from './Pagination.module.css';
import { Left, Right, DobuleLeft, DoubleRight } from 'assets'; 

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const handleFirst = () => {
        if (currentPage !== 1) {
            onPageChange(1);
        }
    };

    const handleLast = () => {
        if (currentPage !== totalPages) {
            onPageChange(totalPages);
        }
    };

    const handlePageClick = (page: number) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 10; 
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    className={`${styles.pageNumber} ${currentPage === i ? styles.active : ""}`}
                    onClick={() => handlePageClick(i)}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    return (
        <div className={styles.pagination}>
            <button onClick={handleFirst} disabled={currentPage === 1} className={styles.skipButton}>
                <DobuleLeft />
            </button>
            <button onClick={handlePrevious} disabled={currentPage === 1} className={styles.navButton}>
                <Left />
            </button>
            <div className={styles.pageNumbersContainer}>{renderPageNumbers()}</div>
            <button onClick={handleNext} disabled={currentPage >= totalPages} className={styles.navButton}>
                <Right />
            </button>
            <button onClick={handleLast} disabled={currentPage >= totalPages} className={styles.skipButton}>
                <DoubleRight />
            </button>
        </div>
    );
};

export default Pagination;
